<template>
  <ScheduleControlRow
    :title="resource.full_name"
    :summary="summary"
    @select="emit('select')"
    @settings="emit('settings')"
  >
    <template #avatar>
      <Avatar
        :alt="resource.full_name"
        :src="resource.avatar?.url ?? ''"
        :status="resource.is_clocked_in ? 'online' : 'offline'"
        :initials="getInitials(resource)"
      />
    </template>
  </ScheduleControlRow>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Avatar from "@/components/Seranova/Indicator/Avatar.vue";
import { getInitials, pluralize } from "@/mixins";
import { ResourceAPIResponse } from "@/typings/scheduler";
import ScheduleControlRow from "./ScheduleControlRow.vue";
import { summaryPeriodLabel } from "./summaryPeriod";
import { technicianLevelLabel } from "./technicianLevel";

const props = defineProps<{
  resource: ResourceAPIResponse;
  appointmentCount: number;
  date: Date;
  weekView?: boolean;
}>();

const emit = defineEmits<{
  (e: "select"): void;
  (e: "settings"): void;
}>();

const summary = computed(() =>
  [
    technicianLevelLabel(props.resource),
    props.resource.department?.name,
    `${props.appointmentCount} ${pluralize(props.appointmentCount, "appt")} ${summaryPeriodLabel(props.date, { weekView: props.weekView })}`
  ]
    .filter(Boolean)
    .join(" · ")
);
</script>
